import React from "react";
import { useController } from "react-hook-form";
import { FirstTimeMessageRecipientInput } from "../inputs/FirstTimeMessageRecipientInput";
import { NameInput } from "../inputs/NameInput";
import { FilterProps } from "../hooks/useFilters";
import { DropdownMultiSelect } from "@/components/FormInputs";
import { InputWrapper } from "@/components/FormInputs/InputWrapper";
import { fixLocations } from "../utils/fixLocations";
import { FilterInput as FilterInputType } from "../types";
import { StartTermInput } from "../inputs/StartTermInput";

const COMMIT_INDEX_ORDER: Record<string, number> = {
  HIGH: 0,
  MEDIUM: 1,
  LOW: 2,
};

export function FiltersForm({
  filters,
  disabled,
}: {
  filters: FilterProps;
  disabled: boolean;
}) {
  const { commitIndex } = filters;

  commitIndex.options = commitIndex?.options?.sort(
    (option1, option2) =>
      COMMIT_INDEX_ORDER[option1.value] - COMMIT_INDEX_ORDER[option2.value],
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 gap-6">
        <NameInput />
        <FilterInput filter={filters.studentType} disabled={disabled} />
        <FilterInput filter={filters.assignedCounselors} disabled={disabled} />
        <StartTermInput
          cohortYears={filters.cohortYear}
          entryTerms={filters.entryTerm}
          disabled={disabled}
        />
        <FilterInput filter={filters.funnelStates} disabled={disabled} />
        <FilterInput filter={filters.majors} disabled={disabled} />
        <FilterInput
          filter={fixLocations(filters.location)}
          disabled={disabled}
        />
        <FilterInput filter={filters.studentSource} disabled={disabled} />
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-6">
          <FilterInput filter={filters.interests} disabled={disabled} />
          <FilterInput filter={filters.commitIndex} disabled={disabled} />
        </div>
        <div>
          <FirstTimeMessageRecipientInput disabled={disabled} />
        </div>
      </div>
    </div>
  );
}

function FilterInput({
  filter,
  disabled,
}: {
  filter: FilterInputType;
  disabled: boolean;
}) {
  const {
    field,
    fieldState: { error },
  } = useController({
    name: `filters.${filter.name}`,
  });

  if (!filter.options) {
    return;
  }

  return (
    <InputWrapper label={filter.label} name={filter.name} error={error}>
      <DropdownMultiSelect
        options={filter.options}
        value={field.value}
        onUpdate={field.onChange}
        placeholder={filter.placeholder}
        allowSearch={!filter.disableSearch}
        disabled={disabled}
      />
    </InputWrapper>
  );
}
